<template>
  <div class="wrapper">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item.processTypeDesc" :name="tabNameList[index]" v-for="(item, index) in processTypeList" :key="tabNameList[index]"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName && processTypeList.length">
      <keep-alive>
        <component :is="activeComponent" :processType="processType"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import retouchTab from './retouch/retouch';
import sectionTab from './section/section';
import bannerImage from './bannerImage/bannerImage';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'ProductShootingImageManagement',
  mixins: [pagePathMixin],
  components: { retouchTab, sectionTab, bannerImage },
  data() {
    return {
      activeName: null,
      processTypeList: [],
      tabNameList: ['retouchTab', 'sectionTab','bannerImage'],
      processType: '',
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    this.getProcessTypeList();
    this.activeName = 'retouchTab';
  },
  methods: {
    handleClick() {},
    getProcessTypeList() {
      this.$q.newProduct.processTypeList().then((res) => {
        this.processTypeList = res.data || [];
        if(!res.data.length) {
          this.$message.error('无权访问该页面!')
          return
        }
        this.processType = res.data.length ? res.data[0].processType : '';
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper
  height calc(100vh - 70px)
  width auto
  border-radius: 5px

  >>> .el-tabs__header
    margin 5px 5px 0px 5px
    padding: 5px 10px
    background: #fff
    border-radius: 5px
</style>
